import { SPThunkAction } from "common/ReduxUtils";
import { InboundStep } from "inbounds/InboundTypes";
import { goToInboundStep } from "./goToInboundStep";
import { updateShipmentId } from "inbounds/store/actions/shipment/updateShipmentId";

export const switchShipmentView = (shipmentId?: number): SPThunkAction => (dispatch) => {
  dispatch(updateShipmentId(shipmentId));
  dispatch(goToInboundStep(InboundStep.SHIP));
};
